/**
 * 列表表单项
 * 根据json渲染表单
 * @author tylerzzheng
 */
import React, { useCallback, useEffect, useMemo } from 'react'
import { DatePicker, Input, Select } from 'antd'
import { FormItemEnable, FormItemIsRequire, FormItemType, IFollowFormItem } from '@types'
import { CommonCascador, CommonSelector } from '@components'
import CosUpload from '../../../../components/COSUpload'
import { opportunityProducts, touchStatus } from '../../../../components/CommonSelector/configs'
import { customerIntention } from '../../../../components/CommonCascador/configs'
import { sortBy } from 'lodash'

const { Option } = Select

interface FormItemRenderProps<T> {
  formItemList?: IFollowFormItem[] // 渲染表单项的数组
  formStore: any
  disabledDate?: (now) => boolean
  disabledDateTime?: any
}

export default function FormItemRender<T extends React.ReactElement> (props: FormItemRenderProps<T>) {
  const { formItemList, formStore, disabledDate, disabledDateTime } = props
  const { Field, useValues } = formStore
  const { setValues } = useValues()

  const renderList: IFollowFormItem[] = useMemo(() => sortBy(formItemList.filter(item => item.enable === FormItemEnable.ENABLE), item => item.order), [formItemList])

  // 设定初始值
  useEffect(() => {
    const defValArrayType = [FormItemType.MUTIL_SELECT, FormItemType.OPPORTUNITY_PRODUCTS]
    renderList.map(item => {
      const defaultEmptyValue = defValArrayType.includes(item.type) ? [] : ''
      if (item?.key) setValues(item.key, item.defaultValue || defaultEmptyValue) // 这里目前除了多选的默认值类型是数组外，其它都是字符串
    })
  }, [renderList])

  const renderFieldItem = useCallback((item: IFollowFormItem) => {
    let ele: React.ReactElement
    switch (item?.type) {
      case FormItemType.INPUT:
        ele = (<Input placeholder={`请输入${item.keyName}`} />)
        break
      case FormItemType.SELECT:
        ele = (
          <Select allowClear>
            {item?.options?.map(opt => (
              <Option key={opt.optionKey} value={opt.optionValue}>{opt.optionName}</Option>
            ))}
          </Select>
        )
        break
      case FormItemType.MUTIL_SELECT:
        ele = (
          <Select mode="multiple" allowClear>
            {item?.options?.map(opt => (
              <Option key={opt.optionKey} value={opt.optionValue}>{opt.optionName}</Option>
            ))}
          </Select>
        )
        break
      case FormItemType.TEXTAREA:
        ele = (<Input.TextArea autoSize={{ minRows: 2 }} placeholder={`请输入${item?.keyName}`} />)
        break
      case FormItemType.FILE:
        ele = (<CosUpload size={10} accept=".jpeg,.jpg,.gif,.png,.doc,.xls,.docx,.xlsx,.pdf,.zip,.rar" />)
        break
      case FormItemType.DATE:
        ele = (<DatePicker showTime={item.key !== 'competingFirm'} disabledDate={disabledDate} disabledTime={disabledDateTime} />)
        break
      case FormItemType.INTENTION:
        ele = (<CommonCascador {...customerIntention} />)
        break
      case FormItemType.TOUCHSTATUS:
        ele = (<CommonSelector {...touchStatus} />)
        break
      case FormItemType.OPPORTUNITY_PRODUCTS:
        ele = (<CommonSelector {...opportunityProducts} mode="multiple" filterOption optionFilterProp="label" />)
        break
      default: ele = <p>-</p>
    }
    return ele
  }, [])

  return (
    <>
      {renderList?.map(item => (
        <Field
          key={item.id}
          field={item.key}
          label={item.keyName}
          help={item.help}
          // initialValue={item.defaultValue} // 不建议用这种方式设定初始值，说多了都是泪
          required={item.isRequire === FormItemIsRequire.YES}
          rule={item.rule}
        >
          {renderFieldItem(item)}
        </Field>
      ))}
    </>
  )
}
